import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { useEffect } from 'react';
import { map } from './Map';

const ReplayAccPathMap = (props) => {
  const { device, positions } = props
  // console.log(`device::::`, device)
  // console.log(` positions::::`, positions)
  const id = 'replayAccPath';

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [] // initially empty
      }
    });
    map.addLayer({
      source: id,
      id,
      type: 'line',
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': [
          'match',
          ['get', 'lineColor'],
          'orange', '#FF5733',
          'red', '#C70039',
          'black', '#333333',
          '#333333' // default
        ],
        'line-width': 5
      }
    });

    // map.on('click', id, (e) => {
    //   const feature = e.features[0];
    //   console.log('Clicked line feature:', feature.properties);
    //   const featureProperties = feature.properties
    //   const position = JSON.parse(featureProperties.position) 
    //   if (position) {
    //     window.open(`https://www.google.com/maps/dir/your+location/${position.latitude},${position.longitude}/@${position.latitude},${position.longitude},17z`, '_blank');
    //   }
    // });

    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  const createFeatureProperty = (position) => {
    const acc = position.acc ? 1 : 0
    const deviceOverSpeed = device.overspeed ? Number(device.overspeed) : 80
    const positionSpeed = Number(position.speed)
    const overSpeed = positionSpeed > deviceOverSpeed ? 1 : 0
    let lineColor = 'black'
    if (positionSpeed > deviceOverSpeed) {
      lineColor = 'orange'
    }
    if (positionSpeed > 1.3 * deviceOverSpeed) {
      lineColor = 'red'
    }
    const featureProperty = {
      deviceId: position.deviceId,
      acc: acc,
      overSpeed: overSpeed,
      speed: positionSpeed,
      deviceOverSpeed: deviceOverSpeed,
      lineColor: lineColor,
      position: position,
    }
    return featureProperty
  }

  const getFeatureList = (positions) => {
    const featureList = []
    for (let k in positions) {
      if (k > 0) {
        const lastPosition = positions[k - 1]
        const position = positions[k]
        const featureProperty = createFeatureProperty(position)
        const feature = {
          type: 'Feature',
          properties: featureProperty,
          geometry: {
            type: 'LineString',
            coordinates: [
              [lastPosition.longitude, lastPosition.latitude],
              [position.longitude, position.latitude]
            ]
          }
        }
        featureList.push(feature)
      }
    }
    return featureList
  }

  useEffect(() => {
    const featureList = getFeatureList(positions)
    console.log(`featureList::::`, featureList)
    map.getSource(id).setData(
      {
        type: 'FeatureCollection',
        features: featureList
      }
    );
  }, [positions]);

  return null;
}

export default ReplayAccPathMap;
